<template>
  <div :class="classTable">
    <el-table
      ref="rootTable"
      style="width: 100%"
      v-loading="loading"
      :data="data2"
      v-bind="$attrs"
      @selection-change="$emit('selection-change', $event)"
      @current-change="$emit('current-change', $event)"
      :max-height="maxheight"
      :stripe="stripe"
    >
      <el-table-column
        label="Expander"
        sortable
        :width="ExpandColumnTreeWith"
        fixed
        :resizable="true"
        :align="ExpandColumnTreeAlign"
        v-if="ExpandTree === true"
      >
      </el-table-column>
      <el-table-column type="selection" width="55" v-if="checkBox">
      </el-table-column>
      <el-table-column
        :width="menuColumnWith"
        fixed
        :align="menuColumnAlign"
        v-if="actions !== undefined && actions.length > 0"
      >
        <template slot="header" slot-scope="scope">
          <i class="el-icon-setting" :key="scope.$index"></i>
        </template>
        <template slot-scope="scope">
          <el-dropdown
            trigger="click"
            @command="handleCommand"
            v-if="
              conditionalActions({
                index: scope.$index,
                row: scope.row,
                column: scope.column
              })
            "
          >
            <span class="el-dropdown-link">
              <i class="mdi mdi-menu"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <template v-for="(action, index) in actions">
                <el-dropdown-item
                  v-if="
                    action.condition !== undefined &&
                    typeof action.condition === 'function'
                      ? action.condition(scope.row)
                      : true
                  "
                  :key="index"
                  :command="{
                    index: scope.$index,
                    row: scope.row,
                    column: scope.column,
                    command: action.command
                  }"
                  :icon="action.icon"
                  :class="[
                    { deleted: action.command.toLowerCase().match(/^.*del.*$/) }
                  ]"
                  >{{ action.label }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>

      <el-table-column
        v-for="(column, index) in columnsfiltered"
        :key="index"
        :type="column.type"
        :formatter="
          typeof column.formatter === 'function' ? column.formatter : null
        "
        v-bind="column"
      >
        <template
          v-if="typeof column.formatter !== 'function'"
          #default="scope"
        >
          {{ /* Enter here only if formatter is not a function if it is let element take care of it. */ }}
          {{ /* If you enter it means that formatter is not a function but it can still be a Vue Component */ }}
          {{ /* therefore it validates if it is a component, otherwise it renders its value. */ }}
          <template
            v-if="
              column.formatter !== undefined &&
              Object.keys(column.formatter).length > 0 &&
              Object.keys(column.formatter).includes('name')
            "
          >
            <div
              :is="column.formatter"
              v-bind="{
                row: scope.row,
                column: column.prop,
                rowValue: arrayGet(scope.row, column.prop),
                ...column.cellAtrrs, // this field must be removed in the next version and use only attrs
                ...column.attrs
              }"
            ></div>
          </template>
          <template v-else>
            {{ arrayGet(scope.row, column.prop) }}
          </template>
        </template>
      </el-table-column>
    </el-table>

    <slot>
      <div style="margin: 10px">
        <el-pagination
          style="margin-top: 20px"
          :layout="layout"
          :current-page="pagination.currentPage"
          :page-size="pageSize"
          :page-sizes="pageSizes"
          :total="pagination.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          v-bind="paginationBind"
        />
      </div>
    </slot>
  </div>
</template>

<script>
import get from "lodash/get";
const arrayGet = get;
import { getPaginatedItems } from "@/utils";

export default {
  name: "RabbeyTable3",
  events: ["rtable-push-action", "update-current-page", "update-page-size"],
  inheritAttrs: false,
  props: {
    /**
     * Css classes for the table container.
     */
    checkBox: {
      type: Boolean,
      default: false
    },
    stripe: {
      type: Boolean,
      default: true
    },
    classTable: {
      type: Object,
      default() {
        return {
          "table-box": true,
          "card-base": true,
          "card-shadow--medium": true
        };
      }
    },
    data: {
      type: Array,
      default: () => []
    },
    initData: {
      type: Array,
      required: false,
      default: () => []
    },
    /**
     * Configuration of the columns of the table.
     * Consulte la documentacion de element.io para
     * ver los demas campos de la columna.
     * Example: columns = [
     *	{
     *		label: "Label",
     *		prop: "Id",
     *		width: 80
     *	}
     *]
     */
    columns: {
      type: Array
    },
    /**
     * Configuration of table actions.
     *
     * Example: actions = [
     *	{
     *		icon: "el-icon-view",
     *		label: "View",
     *		command: "view",
     *    condition: function(row) {
     *			return row.Column === rue;
     *		}
     *	}
     *]
     */
    actions: {
      type: Array,
      required: false
    },
    conditionalActions: {
      type: Function,
      // eslint-disable-next-line no-unused-vars
      default: (payload) => true
    },
    // Activar el loading de la tabla,
    // esto debe ser .sync
    loading: {
      type: Boolean,
      default: false
    },
    // Design del paginador
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
      required: false
    },
    // Cantidad para el selector del paginador
    page_Size: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 30, 40, 100],
      required: false
    },
    maxheight: {
      type: Number,
      default: 700
    },
    search: {
      type: String,
      default: null
    },
    paginateFromApi: {
      type: Boolean,
      default: false
    },
    paginationApi: {
      type: Object,
      required: false,
      default: () => ({
        currentPage: 1,
        pageSize: 10,
        total: 0
      })
    },
    menuColumnWith: {
      Type: Number,
      default: 70
    },
    menuColumnAlign: {
      Type: String,
      default: "center"
    },
    ExpandTree: {
      type: Boolean,
      default: false
    },
    ExpandColumnTreeWith: {
      Type: Number,
      default: 100
    },
    ExpandColumnTreeAlign: {
      Type: String,
      default: "left"
    },
    TabsNoIncludedColumns: {
      type: Array,
      default: () => []
    },
    TabActiveName: {
      type: String,
      default: ""
    },

    paginationBind: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  created() {
    // Asegurar la compatibilidad
    if (!this.paginateFromApi) {
      if (
        this.initData === null ||
        this.initData === undefined ||
        (typeof this.initData === "object" && this.initData.length === 0)
      ) {
        this.dataCache = this.data;
        this.pagination.total = this.data.length;
        this.handleCurrentChange(1);
      } else {
        this.hookInitData(this.initData);
      }
    } else {
      this.data2 = this.data;
    }
  },
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dataCache: [],
      data2: [],
      counter: 0
    };
  },
  computed: {
    pageSize() {
      let ps = Number;
      if (this.page_Size > 0 && this.counter === 0) {
        ps = this.page_Size;
        this.handleSizeChange(this.page_Size);
      } else {
        ps = this.pagination.pageSize;
      }
      if (this.counter === 0) {
        this.sumCounter();
      }
      return ps;
    },
    mapColumnsName() {
      return this.columns.map((col) => col.prop);
    },
    columnsfiltered() {
      let columns = this.columns;
      //console.log("columns: ", this.columns);
      //if (this.TabsNoIncludedColumns.includes(this.TabActiveName) ){
      if (this.TabsNoIncludedColumns.includes(this.TabActiveName)) {
        columns = this.columns.filter(
          (column) =>
            !Object.prototype.hasOwnProperty.call(
              column,
              "noMapped"
            ) /*&& column.noMapped.includes(this.TabActiveName)*/
        );
        //console.log("columnsfiltered: ", columns, "\n TabsNoIncludedColumns: ", this.TabsNoIncludedColumns);
      }

      return columns;
    }
  },
  methods: {
    arrayGet,
    getPaginatedItems,
    sumCounter() {
      this.counter++;
    },
    handleCommand(command) {
      return this.$emit("rtable-push-action", command);
    },
    /**
     * Cambia la cantidad defilas por paginas.
     * @param {int} val Cantidad de filas.
     */
    handleSizeChange(val) {
      if (this.paginateFromApi) {
        this.$emit("update-page-size", val);
      } else {
        this.$emit("update:loading", true);
        this.pagination.pageSize = val;

        const { data } = this.getPaginatedItems(
          this.dataCache,
          this.pagination.currentPage,
          this.pagination.pageSize
        );

        let self = this;
        setTimeout(() => {
          self.$emit("update:loading", false);
          // self.$emit("update:data", data);
          self.data2 = data;
        }, 100);
      }
    },
    /**
     * Cambiar la pagina.
     * @param {int} val Numero de la pagina.
     */
    handleCurrentChange(val) {
      if (this.paginateFromApi) {
        this.$emit("update-current-page", val);
      } else {
        this.$emit("update:loading", true);

        this.pagination.currentPage = val;
        const { data } = this.getPaginatedItems(
          this.dataCache,
          this.pagination.currentPage,
          this.pagination.pageSize
        );

        let self = this;
        setTimeout(() => {
          self.$emit("update:loading", false);
          // self.$emit("update:data", data);
          self.data2 = data;
        }, 100);
      }
    },
    filterData(query) {
      if (typeof query !== "string") {
        throw new Error("RabbeyTable3 -> query debe de tipo string");
      }

      if (query !== "" && query.length > 0) {
        this.$emit("update:loading", true);

        setTimeout(() => {
          this.$emit("update:loading", false);

          let found = [];

          this.mapColumnsName.forEach((col) => {
            this.dataCache.filter((item) => {
              let value = item[col];

              if (value === undefined) {
                return;
              }

              const valueType = typeof value;

              if (valueType === "number" || valueType === "decimal") {
                value = value.toString();
                if (value.indexOf(query) > -1) {
                  found.push(item);
                }
              } else {
                if (value !== null && valueType !== "boolean") {
                  if (Number.isNaN(value)) {
                    if (value.indexOf(query) > -1) {
                      found.push(item);
                    }
                  } else if (
                    value
                      .toLocaleLowerCase()
                      .indexOf(query.toLocaleLowerCase()) > -1
                  ) {
                    found.push(item);
                  }
                }
              }
            });
          });

          const { data } = this.getPaginatedItems(
            found,
            1,
            this.pagination.pageSize
          );

          this.pagination.total = data.length;
          // this.$emit("update:data", data);
          this.data2 = data;
        }, 200);
      } else {
        const { data } = this.getPaginatedItems(
          this.dataCache,
          1,
          this.pagination.pageSize
        );

        this.pagination.total = this.dataCache.length;
        // this.$emit("update:data", data);
        this.data2 = data;
      }
    },
    hookInitData(val) {
      const data = val !== null ? val : [];
      this.dataCache = data;
      this.pagination.total = data.length;
      this.handleCurrentChange(1);
    },
    /**
     * Metodo especial para el re layout de la tabla.
     */
    doLayout() {
      let self = this;
      this.$nextTick(() => {
        try {
          self.$refs.doLayout();
        } catch (e) {
          console.error(e);
        }
      });
    }
  },
  watch: {
    initData(val) {
      const data = val !== null ? val : [];
      this.dataCache = data;
      this.pagination.total = data.length;
      this.handleCurrentChange(1);
    },
    data(val) {
      if (!this.paginateFromApi) {
        this.dataCache = val;
        this.pagination.total = val.length;
        this.handleCurrentChange(1);
      } else {
        this.data2 = val;
      }
    },
    search(val) {
      this.filterData(val);
    },
    items(val) {
      this.data = val;
    },
    paginationApi: {
      handler: function (val) {
        this.pagination = {
          ...this.pagination,
          ...val
        };
      },
      immediate: true,
      deep: true
    }
  }
};
</script>

<style scoped lang="scss">
.el-table--striped .el-table__body tr .el-table__row--striped td {
  background: #fafafa1a;
}
.deleted {
  color: red;
  font-weight: bold;
}
/*
.fixedRow {
    position: sticky;
    bottom: 0;
}
.fixedRow1 {
  position: sticky;
  bottom: 10;
}
.fixedRow2 {
  position: sticky;
  bottom: 20;
}

.fixedRow {
  position: fixed;
  bottom: 0;
  background: greenyellow;
  background-color: greenyellow;
  color: blueviolet;

}
.el-table .fixedRow {
  position: fixed;
  bottom: 0;
  background: greenyellow;
  background-color: greenyellow;
  color: blueviolet;

}
*/
</style>
